export const MODULE_NAME = 'save_page_storage';
export let global_vars = {};

// store page visits in local Storage with the body section type info
let el = {};

export function initialize(global) {
    el.url = global.location.href;
    el.type = global.document.body.dataset.sectionType;
    let regex_cart = new RegExp('cart', 'gi');
    if (!compare_url(el.url, regex_cart)) {
        replace_local_storage('continue_shopping', el);
    }
}

function compare_url(referrer, regex) {
    let match = referrer.match(regex) !== null;
    return match;
}

function replace_local_storage(storage, obj) {
    if (localStorage[storage]) {
        localStorage.removeItem(storage);
    }
    localStorage.setItem(storage, JSON.stringify(obj));
}
